import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteIAPProduct, deleteShopProduct, listIAPProducts, listShopProducts, saveIAPProduct, saveShopProduct } from './api';
import { IAPProductInput, ShopProductInput } from './types';

const SHOP_KEY = ['admin-shop-products'] as const;
const IAP_KEY = ['admin-iap-products'] as const;

export const useShopProducts = () => useQuery({ queryKey: SHOP_KEY, queryFn: listShopProducts });
export const useIAPProducts = () => useQuery({ queryKey: IAP_KEY, queryFn: listIAPProducts });

export function useSaveShopProduct() {
  const client = useQueryClient();
  return useMutation({ mutationFn: ({ input, id }: { input: ShopProductInput; id?: number }) => saveShopProduct(input, id), onSuccess: () => client.invalidateQueries({ queryKey: SHOP_KEY }) });
}
export function useDeleteShopProduct() {
  const client = useQueryClient();
  return useMutation({ mutationFn: deleteShopProduct, onSuccess: () => client.invalidateQueries({ queryKey: SHOP_KEY }) });
}
export function useSaveIAPProduct() {
  const client = useQueryClient();
  return useMutation({ mutationFn: ({ input, editingId }: { input: IAPProductInput; editingId?: string }) => saveIAPProduct(input, editingId), onSuccess: () => client.invalidateQueries({ queryKey: IAP_KEY }) });
}
export function useDeleteIAPProduct() {
  const client = useQueryClient();
  return useMutation({ mutationFn: deleteIAPProduct, onSuccess: () => client.invalidateQueries({ queryKey: IAP_KEY }) });
}
